import React from 'react';
import styles from './donutchart.module.css';
import {numberWithCommas} from '../common/utilities';
import { useTranslation } from 'react-i18next';
import { isNumber } from 'util';
import Grid from '@material-ui/core/Grid';

/*

    Display a Donut Chart

    requires 3 paramaters
        divisor (int)
        dividend (int)
        type (bool)

*/

export default function SVGDonutChart(props) {
        const { t } = useTranslation();

        var text1 = (props.type) ? t('Kills') : t('Wins');
        var text2 = (props.type) ? t('Deaths') : t('Losses');
        var chartBoolean = props.type;

        // these are horrible variable names because the result is different depending on what donut we're making

        var dividend = parseInt(props.dividend, 10) + 0;
        var divisor = parseInt(props.divisor, 10) + 0;
        //console.log('divdend', dividend);
        //console.log('divisor', divisor);

        var dividend_percentage = 0;
        var chartLineStyle = (chartBoolean) ? '_kdr' : '_winrate';
        var displayValue = 0;
        var userValue = 0; // used to calculate circle arc
        var showPercentage = (chartBoolean) ? '' : '%';
        var kdr = '0.00';

        ///////////////////////////////////////
        //
        //	calculate values (if you dare)
        //
        ///////////////////////////////////////

        if (0 < parseInt(dividend, 10) && 0 < parseInt(divisor, 10)) {

            // KDR is a different calculation
            kdr = parseInt((divisor / dividend) * 100, 10) * .01;
            //console.log('kdr', kdr.toFixed(2));

            //divisor = (chartBoolean) ? divisor : parseInt(dividend,10)+ parseInt(divisor,10);
            divisor = parseInt(dividend, 10) + parseInt(divisor, 10);
            dividend_percentage = (dividend / divisor) * 100;
            userValue = ((100 - dividend_percentage) >= 0 && (100 - dividend_percentage) <= 100) ? (100 - dividend_percentage) : 0;
            //console.log('userValue', userValue);
            displayValue = (chartBoolean) ? kdr.toFixed(2) : userValue.toFixed(1);
        }

        if (0 >= parseInt(dividend, 10) && 0 < parseInt(divisor, 10)) {
            dividend_percentage = 0;
            userValue = 100;
            displayValue = (chartBoolean) ? '∞' : 100; // infinity or 100%
        }

        if (0 >= parseInt(divisor, 10) && 0 < parseInt(dividend, 10)) {
            dividend_percentage = 0;
            userValue = 0;
            displayValue = (chartBoolean) ? '0.00' : 0;

        }

        if (0 === parseInt(dividend, 10) && 0 === parseInt(divisor, 10)) {
            dividend_percentage = 0;
            userValue = 0;
            displayValue = 0;
        }

        //console.log('dividend_percentage', dividend_percentage)

        ///////////////////////////////////////
        //
        // set up circle
        //
        ///////////////////////////////////////

        const strokewidth = 2;
        const size = 20;
        var halfsize = (size * 0.5);
        var radius = halfsize;
        var dashArray = radius * Math.PI * 2;
        var dashOffset = dashArray - dashArray * userValue / 100;

        //console.log('dashArray', dashArray);
        //console.log('dashOffset', dashOffset);
        //        strokeDasharray: dashArray,
        //        strokeDashoffset: dashOffset

        //var trackstyle = "strokeWidth: " + strokewidth;
        //console.log('trackstyle', trackstyle);

        var myStyle = styles['donutchartIndicator' + chartLineStyle];

        // using negative offset to reverse the direction
        // React Version (I think, but only necessary if we render from React. We are currently rendering from JS)
        //var indicatorstyle = "strokeDasharray: " + dashArray + "; strokeDashoffset: -" + dashOffset;

        const indicatorstyle = {strokeDasharray: dashArray, strokeDashoffset: -dashOffset};

        // plain old javascript version
        //var indicatorstyle = "stroke-dasharray: " + dashArray + "; stroke-dashoffset: -" + dashOffset;
        //console.log('indicatorstyle', indicatorstyle);

        // start at 12 o'clock instead of 3 (does not work in Safari)
        //var rotateval = 'rotate(-90 ' + halfsize + ',' + halfsize + ')';  // original which we keep
        var rotateval = 'rotate(-90 ' + halfsize + ',' + halfsize + ')';

        try{
            // attempt to do 'something' for Safari mercenaries (start at another clock position and go counter clockwise)
            // https://stackoverflow.com/questions/49328382/browser-detection-in-reactjs
            // Safari 3.0+ "[object HTMLElementConstructor]"
            var safari = (typeof safari !== 'undefined') ? safari : null;
            const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
            //if(navigator.userAgent.indexOf("Safari") !== -1){
            if(isSafari){
                rotateval = 'rotate(90 ' + halfsize + ',' + halfsize + ')';
            }
        }catch(e){
            // can't verify if this browser is Safari
        }

        // <div className={styles.svgDonut} dangerouslySetInnerHTML={{ __html: this.showSVGDonutChart(props.dividend, props.divisor, props.type) }}>

        return (
            <div className={styles.donutContainer}>
                <Grid item xs={9} sm={12} md={12} lg={12} xl={12} className={styles.svgDonut}>
                    <svg viewBox={'0 0 ' + size + ' ' + size} className={styles.donutchart} style={{maxHeight: '285px'}}>
                        <circle r={radius} cx={halfsize} cy={halfsize} fill="none" className={styles.donutchartTrack}></circle>
                        <circle r={radius} cx={halfsize} cy={halfsize} fill="none" transform={rotateval} className={myStyle} style={indicatorstyle}></circle>
                        <text className={styles.donutchartText} x={halfsize} y={halfsize}>
                            <tspan>
                                <tspan x="10" y="12" className={styles.donutchartTextVal}>{displayValue}{showPercentage}</tspan>
                            </tspan>
                        </text>
                    </svg>
                </Grid>
                <div className={styles.text}>
                    <div className={styles.statValueFlexContainer}>
                        <h5>{text1}</h5>
                        <h3>{numberWithCommas(props.divisor)}</h3>
                    </div>
                    <div className={styles.statValueFlexContainer}>
                        <h5>{text2}</h5>
                        <h3>{numberWithCommas(props.dividend)}</h3>
                    </div>
                </div>
            </div>
        );
}
